export default {
  production: true,
  environmentName: '{{#ENVIRONMENT#}}',
  api: '{{#API_URL#}}',
  apiCertificates: '{{#API_CERTIFICATES_URL#}}',
  apiLossPrevention: '{{#API_LOSS_PREVENTION_URL#}}',
  apiTrfRem: '{{#API_TRF_REM_URL#}}',
  apiKnowledgePortal: '{{#API_KNOWLEDGE_PORTAL_URL#}}',
  urlExtranet: '{{#EXTRANET_URL#}}',
  fileSizeLimit: '{{#FILE_SIZE_LIMIT#}}',

  newRelic: {
    accountId: '{{#NR_ACCOUNT_ID#}}',
    trustKey: '{{#NR_TRUST_KEY#}}',
    agentId: '{{#NR_APP_ID#}}',
    licenseKey: '{{#NR_BROWSER_LICENSE_KEY#}}',
  },
};
